"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.placeSimilar = void 0;
var React = require("react");
var ResultItemComponent_1 = require("@/pages/search/components/ResultItemComponent");
exports.placeSimilar = function (props) {
    if (!props.similarProperties || !props.similarProperties.length) {
        return null;
    }
    var similarStyle = {
        backgroundColor: '#fcfcfc',
    };
    var renderResultItem = function (it, index) {
        return (React.createElement("div", { className: "c-propertyrow__item", key: index },
            React.createElement(ResultItemComponent_1.default, { item: it, t: props.resultPageTranslation, filterType: props.type, symbol: props.symbol, googleApi: props.googleApikey, lang: props.lang, lazy: true, onEnquireClicked: props.onSimilarEnquireClicked, onMouseDown: props.onSimilarMouseDown, onMouseUp: props.onSimilarMouseUp, onItemClicked: props.onItemClicked })));
    };
    return (React.createElement("div", { className: "u-nofav", style: similarStyle },
        React.createElement("div", { className: "l-pad-top--4 l-pad--4" },
            React.createElement("div", { className: "l-container l-container--lr" },
                React.createElement("div", { className: "l-container__main" },
                    React.createElement("h2", { className: "c-building__place-head" }, props.t.similarProperties))),
            React.createElement("div", { className: "l-container l-container--lr c-place__similar" },
                React.createElement("div", { className: "c-result  l-container__main", "custom-sliderinit": props.similarSliderInit ? '1' : '0' },
                    React.createElement("div", { className: "c-propertyrow" },
                        React.createElement("div", { id: "similar-group", className: "c-propertyrow__group" }, props.similarProperties.map(function (it, i) { return renderResultItem(it, i); }))),
                    React.createElement("div", { className: "c-propertyrow__controls" },
                        React.createElement("div", { className: "c-propertyrow__control-offset" },
                            React.createElement("div", { onClick: props.similarPrev, className: "c-propertyrow__btn c-propertyrow__btn--prev" }),
                            React.createElement("div", { onClick: props.similarNext, className: "c-propertyrow__btn c-propertyrow__btn--next" }))))))));
};
